var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current inline-block",class:_vm.size?`w-${_vm.size} h-${_vm.size}`:`w-6 h-6`,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"d":"M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }